import React, { useContext } from 'react';
import { LineTitle } from '../../inventory/article';
import Moment from 'react-moment';
import { UserIndexContext } from '../../../context/security/UserIndexProvider';
import { FORMAT_DATE_TIME_MOMENT } from '../../../api/constant';
import { CreateUser } from './form/CreateUser';

export const UsersIndex = () => {
  const [{ listUsersState }, { goToUserEdit }] = useContext(UserIndexContext);

    return (
        <div className="container-fluid">
            <LineTitle title={"Usuarios"} />

            <CreateUser />

            <LineTitle />

            <table className="table table-default-app">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">ID de creación</th>


                        <th scope="col">Fecha creación</th>

                        <th scope="col">Nombres y apellidos</th>
                        <th scope="col">Correo electrónico</th>
                        <th scope="col">Última modificación</th>
                    </tr>
                </thead>
                <tbody>
                    {listUsersState.elements.map((item) => {
                        return (
                            <tr key={item.id} className="cursor-pointer td-hoverme" onClick={() => goToUserEdit(item.id)}  >
                                <td>
                                    <span className="cursor-pointer">{item.id}</span>
                                </td>
                                <td>
                                    <Moment format={FORMAT_DATE_TIME_MOMENT}>
                                        {item.created_at}
                                    </Moment>
                                </td>

                                <td>{item.name}</td>
                                <td>{item.email}</td>

                                <td>
                                    <Moment format={FORMAT_DATE_TIME_MOMENT}>
                                        {item.updated_at}
                                    </Moment>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

        </div>
    )
}
